/**
 *  * Rôle : Module partage social
 * Copyright: © 2021 Remote Monkey S.A.S.U http://remote-monkey.fr
 */
import React from 'react';
import H2 from '../../../functional/H2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { Link } from 'gatsby'

export default function ShareSideBar() {
	return (
		<div className="mt-5 bg-gray-100 p-10">
			<H2>Réseaux sociaux</H2>
			<div className="flex items-center justify-between w-full text-2xl mt-10 text-white">
				<a
					href={`${process.env.GATSBY_FB_SOCIAL_URL}`}
					target="_blank"
					rel="noreferrer"
					className="hover-ride-top-large hover:opacity-60 animate rounded-full w-10 h-10 flex items-center justify-center"
					style={{ backgroundColor: '#395498' }}
				>
					{' '}
					<FontAwesomeIcon icon={['fab', 'facebook']} />{' '}
				</a>
				<a
					href={`${process.env.GATSBY_YTB_SOCIAL_URL}`}
					target="_blank"
					rel="noreferrer"
					className="hover-ride-top-large hover:opacity-60 animate rounded-full w-10 h-10 flex items-center justify-center"
					style={{ backgroundColor: '#f50100' }}
				>
					{' '}
					<FontAwesomeIcon icon={['fab', 'youtube']} />{' '}
				</a>
				<a
					href={`${process.env.GATSBY_INSTA_SOCIAL_URL}`}
					target="_blank"
					rel="noreferrer"
					className="hover-ride-top-large hover:opacity-60 animate rounded-full w-10 h-10 flex items-center justify-center bg-gradient-to-tr from-yellow-300 via-red-500 to-indigo-500"
				>
					{' '}
					<FontAwesomeIcon icon={['fab', 'instagram']} />{' '}
				</a>
				<a
					href={`${process.env.GATSBY_TWITTER_SOCIAL_URL}`}
					target="_blank"
					rel="noreferrer"
					className="hover-ride-top-large hover:opacity-60 animate rounded-full w-10 h-10 flex items-center justify-center"
					style={{ backgroundColor: '#009ded' }}
				>
					{' '}
					<FontAwesomeIcon icon={['fab', 'twitter']} />{' '}
				</a>
			</div>
		</div>
	);
}
